import template from './agencies.html';
import controller from './agencies.controller';

let agenciesComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default agenciesComponent;
